export const NATIVE_ROLL_INDEX_DESKTOP = -1; // Disabled
export const NATIVE_ROLL_INDEX_MOBILE = -1; // Disabled
export const BANNERS_BY_INDEX_DESKTOP = {
    2: '690x240_1',
    4: 'articlePartner',
    7: 'inPageVideo',
    12: '690x240_2',
    16: '690x240_3',
    20: '690x240_4',
};
export const BANNERS_BY_INDEX_MOBILE = {
    2: '300x250_2',
    4: 'articlePartner',
    7: 'inPageVideo',
    12: '300x250_3',
    16: '300x250_4',
    20: '300x250_5',
    24: '300x250_6',
};
export const ARTICLE_BOXES = {
    ad: () => import('~/components/BoxAdfox/BoxAdfox.vue'),
    article: () => import('~/components/BoxArticle/BoxArticle.vue'),
    attachment: () => import('~/components/BoxAttachment/BoxAttachment.vue'),
    block: () => import('~/components/BoxBlock/BoxBlock.vue'),
    'cards-slider': () => import('~/components/BoxCardsSlider/BoxCardsSlider.vue'),
    'custom-block': () => import('~/components/BoxCustomBlock/BoxCustomBlock.vue'),
    customEmbed: () => import('~/components/BoxCustomEmbed/BoxCustomEmbed.vue'),
    embed: () => import('~/components/BoxEmbed/BoxEmbed.vue'),
    'franchise-list': () => import('~/components/BoxFranchiseList/BoxFranchiseList.vue'),
    gallery: () => import('~/components/BoxGallery/BoxGallery.vue'),
    header: () => import('~/components/BoxHeading/BoxHeading.vue'),
    'custom-header': () => import('~/components/BoxHeadingExtended/BoxHeadingExtended.vue'),
    image: () => import('~/components/BoxImage/BoxImage.vue'),
    list: () => import('~/components/BoxList/BoxList.vue'),
    'list-slider': () => import('~/components/BoxListSlider/BoxListSlider.vue'),
    listOfValues: () => import('~/components/BoxListOfValues/BoxListOfValues.vue'),
    modal: () => import('~/components/BoxModal/BoxModal.vue'),
    'native-roll': () => import('~/components/BoxNativeRoll/BoxNativeRoll.vue'),
    paragraph: () => import('~/components/BoxParagraph/BoxParagraph.vue'),
    promo: () => import('~/components/BoxPromo/BoxPromo.vue'),
    'promo-socials': () => import('~/components/BoxPromo/BoxPromo.vue'),
    quote: () => import('~/components/BoxQuote/BoxQuote.vue'),
    rating: () => import('~/components/BoxRating/BoxRating.vue'),
    'related-list': () => import('~/components/BoxList/BoxList.vue'),
    table: () => import('~/components/BoxTable/BoxTable.vue'),
};
export const OBSERVABLE_TYPES = [
    'attachment',
    'block',
    'header',
    'header-extended',
    'list',
    'list-slider',
    'paragraph',
    'quote',
    'related-list',
    'table',
];
export const AT_TOP_ADMARK_RUBRICS = ['sport', 'franchises', 'sustainability', 'healthcare', 'club'];
